/**
 * @desc 批量编辑加油站ACommissionSetUp
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.BatchCommissionSet): Promise<BaseResponse<defs.ResultBean>> {
  return fetch({
    url: config.API_HOST + '/stationCommission/updateBatch',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
